import React from 'react';
import { Star } from 'lucide-react';

export const StarRating = ({ rating }) => (
  <>
    {Array.from({ length: 5 }, (_, index) => (
      <Star
        key={index}
        className={`w-5 h-5 ${
          index < rating ? 'fill-brand-primary text-brand-primary' : 'text-border-medium'
        }`}
      />
    ))}
  </>
);
